import { render, staticRenderFns } from "./ToursDetails.vue?vue&type=template&id=5ded7f28"
import script from "./ToursDetails.vue?vue&type=script&lang=js"
export * from "./ToursDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports